export const AGENT_IDS = {
  WORKFLOW_ROUTING: 'workflow_routing',
} as const;

export type AgentId = (typeof AGENT_IDS)[keyof typeof AGENT_IDS] | null;
